var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("input", {
          staticClass: "mt-2",
          attrs: {
            accept: "image/*",
            type: "file",
            multiple: "",
            name: "fotos",
            id: "fotos"
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-success",
            attrs: { type: "button" },
            on: { click: _vm.subir }
          },
          [
            _c("i", { staticClass: "fa fa-upload" }),
            _c("span", [_vm._v("Subir fotos")])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.fotos, function(foto, index) {
        return _c("div", { key: index, staticClass: "col-xs-12 col-md-3" }, [
          _c(
            "button",
            {
              staticClass: "btn-danger btn--text",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.eliminarFoto(index)
                }
              }
            },
            [_c("i", { staticClass: "fa fa-times" })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                download: "",
                href: _vm.url + "/storage/" + foto.path_foto
              }
            },
            [
              _c("img", {
                attrs: {
                  height: "150px",
                  width: "100%",
                  src: _vm.url + "/storage/" + foto.path_foto,
                  alt: "Foto"
                }
              })
            ]
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e29d152", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e29d152","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/clientes/FotosClientes.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6e29d152","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/clientes/FotosClientes.vue
// module chunks = 0